(function() {
    var m = angular.module('utils');

    m.directive('year', [function() {
        return {
            require: 'ngModel',
            priority: 1,
            link: function(scope, elm, attrs, ngModel) {

                var e = $(elm);

                function fillYears() {
                    e.html('');
                    for(var i = 1930; i<= (new Date()).getFullYear(); i++) {
                        e.append($('<option>').val(i).html(i));
                    }
                }

                scope.$watch(function() {
                    return ngModel;
                }, function() {
                    fillYears();
                    e.val(ngModel.$viewValue);
                });
            }
        };
    }]);
})();
